import Vue from "vue";
import { AclCreate, AclInstaller, AclRule } from "../lib/acl";
import router from "../router";
import session from "../util/session";

Vue.use(AclInstaller);

export default new AclCreate({
    initial: "public",
    notfound: {
        path: "/tidak-ditemukan",
        forwardQueryParams: true,
    },
    router,
    acceptLocalRules: true,
    globalRules: {
        isPublic: new AclRule("public").generate(),
        isAdmin: new AclRule("ADMIN").generate(),
        isInputer: new AclRule("INPUTER").or("ADMIN").generate(),
        isLpa: new AclRule("INPUTER")
            .or("USER")
            .or("ADMIN")
            .generate(),
        isLogged: new AclRule("USER")
            .or("ADMIN")
            .generate()
    },
    middleware: async(acl) => {
        let cache = session.get.user();
        if (cache.role) acl.change(cache.role);
        else acl.change("public");
    },
});